import BaseCheckbox from "../baseComponents/baseCheckbox";
import BaseParagraph from "../baseComponents/baseParagraph";
import useColors from "../customHooks/useColors";
import { useSelector } from "react-redux";
import BaseRequiredMark from "../baseComponents/BaseRequiredMark";

const NotificationsCheckbox = ({
  value,
  onChange = () => {},
  disabled = false,
}) => {
  const [currentColors] = useColors();

  const systemState = useSelector((state) => state.systemState);

  return (
    <BaseCheckbox value={value} onChange={onChange} disabled={disabled}>
      <BaseParagraph>wantToReceiveNotifications</BaseParagraph>
      {systemState.settings.req_permission3 && <BaseRequiredMark />}
    </BaseCheckbox>
  );
};

export default NotificationsCheckbox;
